module.exports = __webpack_public_path__ + "images/emoji/potable_water.ca72dbebedad2e8939f2.png";